import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useCheckPermissionOR } from 'hooks';

import * as servicesChat from 'services/chatServices';
import { SECURE_CONFIG } from 'utils/SecureRoute';
const TOTAL_UNREAD_MESSAGE_KEY = ['get-total-unread-message'];
export const useGetTotalUnreadMessage = (rest = {}) => {
  const queryClient = useQueryClient();

  const checkPermission = useCheckPermissionOR();

  const canChat = checkPermission([
    SECURE_CONFIG.CHAT_COMPANY.PASS,
    SECURE_CONFIG.CHAT_PERSONAL.PASS,
  ]);

  const queries = useQuery({
    queryKey: TOTAL_UNREAD_MESSAGE_KEY,
    queryFn: async () => {
      const response = await servicesChat.getEmailAndMessageNotify();
      return response?.data;
    },
    enabled: canChat,
    meta: {
      onError: () => {
        return false;
      },
    },
    ...rest,
  });

  const refetchTotalUnreadMessage = () => {
    queryClient.invalidateQueries({
      queryKey: TOTAL_UNREAD_MESSAGE_KEY,
    });
  };

  return {
    ...queries,
    refetchTotalUnreadMessage,
  };
};
